export const PROJECT_USERS_API = "projectUsers";
export const PROJECTS_API = "projects";
export const USERS_API = "users";
export const REPORTS_API = "reports";
export const INIT_API = "init";
export const IMAGES_API = "images";
export const READ_API = "read";
export const UNREAD_API = "unread";
export const CHECK_API = "check";
export const RESET_API = "reset";
export const UPDATE_INFO_API = "updateInfo";
export const ACCEPT_API = "accept";
export const REJECT_API = "reject";
export const REORDER_API = "reorder";
export const EXPORT_API = "export";
export const IMPORTS_API = "imports";
export const TYPES_API = "types";

export const TRANSACTIONS_REVIEW_API = "transactionsReview";

export const CONTACT_REPORT_API = "contact";
export const CONTACT_REVIEW_REPORT_API = "contactReview";

export const DASHBOARD_API = "dashboard";
export const GET_IMAGE_API = "getImage";
export const GET_CASH_REMAIN_API = "getCashRemain";
export const GET_CLASSIFICATION_API = "getClassification";
export const GET_PAYMENT_API = "getPayment";
export const GET_CLASSIFIED_EXPENDITURES_API = "getClassifiedExpenditures";
export const GET_CUSTODIAN_BALANCE_API = "getCustodianBalance";
export const GET_PENDING_LIST_API = "getPendingList";

export const HASHTAG_SUMMARY_API = "hashtagSummary";
export const HASHTAG_LIST_API = "hashtagList";
export const HASHTAG_REVIEW_API = "hashtagReview";

export const MONTHLY_API = "monthly";
export const MONTHLY_REVIEW_API = "monthlyReview";
export const MONTHLY_BY_ACCOUNT_TITLES_API = "monthlyByAccountTitles";
export const MONTHLY_BUDGETS_API = "monthlyBudgets";
export const MONTHLY_BUDGET_API = "monthlyBudget";
export const MONTHLY_BUDGET_LIST_API = "monthlyBudgetList";

export const CLASSIFIED_EXPENDITURES_API = "classifiedExpenditures";
export const CLASSIFIED_EXPENDITURES_REVIEW_API =
  "classifiedExpendituresReview";

export const PAYMENTS_API = "payments";
export const RECEIVES_API = "receives";

export const IMPRESTS_API = "imprests";
export const TRASHED_SEQUENCE_API = "trashedSequences";
export const ITEMS_API = "items";
export const IMPREST_DETAILS_API = "imprestDetails";
export const IMPREST_FILTER_API = "imprestFilter";
export const SEND_API = "send";
export const RETURN_API = "return";
export const REQUEST_RETURN_API = "requestReturn";
export const REJECT_TO_API = "reject";
export const REJECT_FINALIZE_API = "rejectFinalize";
export const FINALIZE_API = "finalize";
export const APPROVE_API = "approve";
export const IMPRESTS_BUDGETS_API = "imprestBudgets";
export const IMPRESTS_BUDGET_API = "imprestBudget";
export const CURRENT_COMPARISON_API = "currentComparison";
export const IMPRESTS_BUDGETS_COMPARISON_API = "imprestBudgetComparison";
export const IMPREST_BY_ACCOUNT_TITLE_API = "imprestByAccountTitles";
export const IMPREST_BY_ACCOUNT_TITLE_WITH_DETAIL_API =
  "imprestByAccountTitlesWithDetail";
export const IMPREST_BUDGET_BY_ACCOUNT_TITLE_API =
  "imprestBudgetByAccountTitle";

export const VAT_REVIEW_API = "valueAdded";

export const ACCOUNT_TITLES_API = "accountTitles";
export const DEFAULT_ACCOUNT_TITLES_API = "defaultAccountTitles";

export const CONTACTS_API = "contacts";

export const COST_CENTERS_API = "costCenters";

export const HASHTAGS_API = "hashtags";

export const ANNOUNCEMENTS_API = "announcements";
export const NOTIFICATIONS_API = "notifications";
export const FEEDBACK_API = "feedback";
export const REJECT_INVITATION_API = "rejectInvitation";
export const ACCEPT_INVITATION_API = "acceptInvitation";
export const SEND_REFERENCE_LINK_API = "sendReferenceLink";

export const CURRENCIES_API = "currencies";

export const FILES_API = "files";

export const AUTH_LOGIN_API = "login";
export const AUTH_REGISTER_API = "register";
export const AUTH_VERIFY_API = "verify";
export const AUTH_RESET_PASSWORD_API = "resetPassword";
export const AUTH_CHECK_REFERENCE_CODE_API = "checkReferenceCode";
export const AUTH_RESEND_OTP_API = "resendOtp";

export const PREMIUM_API = "premium";
export const CALCULATE_PRICE_API = "calculatePrice";
export const PAY_API = "pay";
export const PURCHASE_TRANSACTIONS_API = "transactions";
export const PROMO_CODES_API = "promoCodes";
export const ACTIVE_PLANS_API = "activePlans";

export const INVITATION_API = "invitation";
export const ARCHIVE_API = "archive";
export const PROJECT_USER_LIST_API = "projectUserList";
export const PROJECT_TYPES_API = "projectTypes";

export const SOFTWARE_SETTINGS_API = "softwareSettings";
export const FORM_SETTINGS_API = "formSettings";
export const FORM_VALIDATION_SETTINGS_API = "formValidationSettings";
export const ACCOUNTING_SOFTWARES_API = "accountingSoftwares";

export const LOCATION_API = "location";
export const PROVINCES_API = "provinces";
export const CITIES_API = "cities";

export const TEAMS_API = "teams";
export const TEAM_LEVELS_API = "teamLevels";
export const TEAM_LEVEL_USERS_API = "teamLevelUsers";
export const TEAM_UPDATE_WIDGET_API = "updateWidgets";

export const TICKETS_API = "tickets";
export const TICKET_MESSAGES_API = "ticketMessages";

export const BULK_DELETE_API = "bulkDelete";
export const COPY_TRANSACTION_API = "copyTransaction";

export const USER_API = "user";
export const CHANGE_PASSWORD_API = "changePassword";

export const USER_MANAGEMENT_API = "userManagement";
export const CHECK_PHONE_NUMBER_API = "checkPhoneNumber";
export const INVITE_API = "invite";
export const REACTIVATE_API = "reactivate";
export const DEACTIVATE_API = "deactivate";
export const DELETE_INVITATION_API = "deleteInvitation";
export const CONVERT_TO_MANAGER_API = "convertToManager";
export const CONVERT_TO_ADMIN_API = "convertToAdmin";
export const INVITE_TO_OTHER_TEAMS_API = "inviteToOtherTeams";
export const REMOVE_FROM_TEAM_API = "removeFromTeam";
export const CHANGE_TEAM_PERMISSIONS_API = "changeTeamPermissions";
export const SHARED_PROJECTS_API = "sharedProjects";
export const GET_ACCOUNTING_CODES_API = "getAccountingCodes";
export const EDIT_ACCOUNTING_CODES_API = "editAccountingCodes";
export const GET_IMPREST_PAYMENT_LIMIT_API = "getImprestPaymentLimit";
export const EDIT_IMPREST_PAYMENT_LIMIT_API = "editImprestPaymentLimit";

export const WARN_OWNER_API = "warnOwner";

export const TRANSACTIONS_API = "transactions";
export const CREAT_MISSING_OBJECTS_API = "createMissingObjects";
export const GET_ITEMS_API = "getItems";
export const STORE_ITEMS_API = "storeItems";

export const UPDATE_ACCOUNT_TITLE_LEVEL = "updateAccountTitleLevel";
export const UPDATE_USE_IMPREST_SEQUENCE = "updateUseImprestSequence";
export const UPDATE_USE_API_TOKEN = "updateUseApiToken";
export const UPDATE_CONNECT_TO_PARTNERS = "updateConnectToPartners";
export const UPDATE_TRANSACTION_DAY_LIMIT = "updateTransactionDayLimit";

export const SUB_ACCOUNT_TITLES_API = "subAccountTitles";
